import ms from 'ms';
import { useQuery } from 'react-query';

import { toast } from '@hivebrite/design-system/Toast';

import { QUERY_KEYS } from 'hb-react/backoffice/components/CategoriesList/v2/constants';
import { getCategories } from 'hb-react/backoffice/components/CategoriesList/v2/requests';
import type { ConfigUrls } from 'hb-react/backoffice/components/CategoriesList/v2/types';
import type { Network } from 'hb-react/types';

interface GetCategoriesProps {
  configUrls: Pick<ConfigUrls, 'getCategoriesPath'>;
  type: string;
  topicId?: number;
  networkId: Network['id'];
}

export const useGetCategories = ({
  configUrls,
  type,
  topicId,
  networkId,
}: GetCategoriesProps) => {
  const { data: categories = [], isLoading } = useQuery(
    [QUERY_KEYS.categories, type, topicId, networkId],
    () => getCategories(configUrls),
    {
      staleTime: ms('5m'),
      onError: () => toast.error(__('Sorry, an error occurred')),
    },
  );

  return { categories, isLoading };
};
